module.exports = __webpack_public_path__ + "static/akwarium-2-ca29521e16b9ae182f8e6d15391911b2.jpg";